import { Dash, Pen, Plus, Trash } from "react-bootstrap-icons";
import productService from "../services/productService";
import { useState } from "react";
import CustomSpinner from "./CustomSpinner";
import ProductForm from "./ProductForm";
import { PIECEWORK_TYPES } from "../constants/business";

export default function ProductItem({ product, products, onChange }) {

  const [loading, setLoading] = useState(false);

  const [fields, setFields] = useState({ delta: 1 });

  const [modalEditar, setModalEditar] = useState(false);
  const OpenCLoseForm = () => setModalEditar(!modalEditar);
  const [modalEliminar, setModalEliminar] = useState(false);
  const OpenCLoseModalEliminar = () => setModalEliminar(!modalEliminar);

  const handleDelete = async () => {
    setLoading(true);
    await productService.delete(product.id).catch((err) => {
      alert("Error deleting product:", err);
    });
    onChange();
    OpenCLoseModalEliminar();
    setLoading(false);
  };

  const handleSell = async () => {

    if (fields.delta > 0) {
      setLoading(true);
      try {
        await productService.updateStock(product.id, (-1 * fields.delta));
      } catch (error) {
        alert(error.response?.data?.message || "Error updating stock");
      }
      onChange();
      setLoading(false);
    }

  };

  const handleAdd = async () => {
    if (fields.delta > 0) {
      setLoading(true);
      try {
        await productService.updateStock(product.id, Number.parseInt(fields.delta));
      } catch (error) {
        alert(error.response?.data?.message || "Error updating stock");
      }
      onChange();
      setLoading(false);
    }
  };

  return (
    <>
      {
        loading && (<CustomSpinner />)
      }
      <article className="mb-2 rounded-2xl border border-sky-500/30 bg-slate-50/60 shadow-sm dark:bg-slate-900/60">
        <header className="flex justify-between border-b border-black/10 p-3 dark:border-white/10">
          <button className="btn btn-warning p-2" onClick={() => OpenCLoseForm()} aria-label="Editar"><Pen /></button>
          <button className="btn btn-danger p-2" onClick={() => OpenCLoseModalEliminar()} aria-label="Eliminar"><Trash /></button>
        </header>
        <div className="p-4">
          <h2 className="text-lg font-semibold">{product.name}</h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
            {product.catalogType && <>
              Tipo: {product.catalogType}
              <br />
            </>}
            {product.catalogType === "Producto terminado" && product.pieceworkType && <>
              Tipo de destajo: {PIECEWORK_TYPES.find(({ value }) => value === product.pieceworkType)?.label || product.pieceworkType}
              <br />
            </>}
            {product.stock !== null && product.stock !== undefined && product.stock !== "" && <>
              Existencia: {product.stock} {product.unit}
              <br />
            </>}
            {product.color && <>
              Color: {product.color}
              <br />
            </>}
            {product.price !== null && product.price !== undefined && product.price !== "" &&
              <>Precio: ${product.price}</>}
          </p>
        </div>
        <footer className="border-t border-black/10 p-4 dark:border-white/10">
          <label className="mb-3 block text-sm font-medium">Cantidad ({product.unit})<input className="form-control mt-2" type="number"
            placeholder="x"
            value={fields.delta}
            onChange={(e) =>
              setFields({ ...fields, delta: e.target.value })}
          /></label>
          <button className="btn btn-danger mr-2" onClick={() => handleSell()}><Dash /> Salida</button>
          <button className="btn btn-success" onClick={() => handleAdd()}><Plus /> Entrada</button>
        </footer>
      </article>

      <ProductForm onSuccess={onChange} product={product} products={products} show={modalEditar} setShow={setModalEditar} isEdit={true} />

      {modalEliminar && <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 p-4" role="dialog" aria-modal="true">
        <div className="w-full max-w-md rounded-2xl border border-black/10 bg-slate-50 p-6 shadow-2xl dark:border-white/10 dark:bg-slate-900">
          <h2 className="text-lg font-semibold">Eliminar Producto</h2><p className="my-5 text-sm">¿Estás seguro de que deseas eliminar el producto {product.name}?</p>
          <div className="flex justify-end gap-2"><button className="btn border-slate-300 dark:border-slate-700" onClick={() => OpenCLoseModalEliminar()}>Cerrar</button><button className="btn btn-danger" onClick={handleDelete}>Eliminar</button></div>
        </div>
      </div>}
    </>
  );
}
